import { SxProps, Theme } from "@mui/material";
import { assessmentTabletLandscapeMedia, assessmentShortViewportMedia } from "../../assessment-layout-styles";

const sidebarReservePadding = (hasSidebar: boolean): SxProps<Theme> =>
  hasSidebar
    ? {
        pr: { xs: 0, md: "328px" },
        [assessmentTabletLandscapeMedia]: {
          pr: "276px",
        },
      }
    : {};

export const containerStyle: SxProps<Theme> = (theme) => ({
  backgroundColor: theme.palette.quizPopap.quizInsideBg,
  p: { xs: 2, sm: 4, md: 6 },
  borderRadius: 2,
  [assessmentShortViewportMedia]: {
    p: 0,
    borderRadius: 0,
    backgroundColor: "transparent",
  },
});

export const questionHeaderStyle: SxProps<Theme> = {
  fontWeight: 600,
  color: "#06B6D4",
  fontSize: { xs: "14px", sm: "16px" },
};

export const questionTextStyle: SxProps<Theme> = (theme) => ({
  color: theme.palette.quizPopap.quizText,
  mb: { xs: 0.25, sm: 1 },
  fontSize: { xs: "15px", sm: "18px" },
  fontWeight: 700,
  lineHeight: { xs: 1.45, sm: 1.5 },
  [assessmentShortViewportMedia]: {
    fontSize: "14px",
    mb: 0.25,
    lineHeight: 1.35,
  },
});

export const questionAreaStyle = (hasSidebar: boolean): SxProps<Theme> =>
  sidebarReservePadding(hasSidebar);

export const dividerStyle: SxProps<Theme> = (theme) => ({
  my: { xs: 1.5, sm: 4 },
  borderColor: theme.palette.quizPopap.quizSeparator,
  borderBottomWidth: "1px",
  [assessmentShortViewportMedia]: {
    my: 0.75,
  },
});

export const answerAreaLayoutStyle = (
  hasSidebar: boolean,
  isOpenText: boolean
): SxProps<Theme> => ({
  position: "relative",
  display: "block",
  ...sidebarReservePadding(hasSidebar),
  minHeight: hasSidebar ? { xs: "auto", md: "180px" } : "auto",
  pb: isOpenText ? { xs: 1.5, md: 2 } : 0,
});

export const answerAreaContentStyle: SxProps<Theme> = {
  minWidth: 0,
};

export const answerAreaSidebarStyle: SxProps<Theme> = {
  minWidth: 0,
  mt: { xs: 2, md: 0 },
  position: { xs: "static", md: "absolute" },
  top: 0,
  right: 0,
  width: { xs: "100%", md: "296px" },
  [assessmentTabletLandscapeMedia]: {
    width: "244px",
  },
};

export const postAnswerMetaStyle: SxProps<Theme> = {
  mt: 2,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 1.5,
};

export const questionWinnerStyle: SxProps<Theme> = (theme) => ({
  mt: 2,
  px: 2,
  py: 1.5,
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  flexWrap: "wrap",
  backgroundColor: theme.palette.quizPopap.quizSelector,
  border: `1px solid ${theme.palette.quizPopap.quizSeparator}`,
  color: theme.palette.quizPopap.quizText,
});

export const questionWinnerIconStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#D4A017",
  flexShrink: 0,
};

export const questionWinnerTextStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 600,
};

export const questionWinnerSeparatorStyle: SxProps<Theme> = {
  width: 4,
  height: 4,
  borderRadius: "50%",
  backgroundColor: "rgba(15, 23, 42, 0.28)",
  flexShrink: 0,
};

export const questionWinnerMetaStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 500,
  opacity: 0.8,
};

export const formControlStyle: SxProps<Theme> = {
  "& .MuiFormControlLabel-label.Mui-disabled": {
    color: "inherit !important",
  },
};

export const radioStyle: SxProps<Theme> = (theme) => ({
  color: theme.palette.quizPopap.quizRadio,
  "&.Mui-checked": {
    color: "#06B6D4",
  },
});

export const getOptionStyle = (
  ansText: string,
  ansPoints: number,
  selectedAnswer: string,
  isAnswerChecked: boolean,
  theme: Theme,
): SxProps<Theme> => {
  let style: SxProps<Theme> = {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    ml: 0,
    mb: { xs: 0.75, sm: 1 },
    paddingX: { xs: 1, sm: 2, md: 4 },
    paddingY: { xs: "10px", sm: "16px" },
    borderRadius: "8px",
    backgroundColor: theme.palette.quizPopap.quizSelector,
    border: "1px solid transparent",
    color: theme.palette.quizPopap.quizSelectorText,
    "& .MuiFormControlLabel-label": {
      fontSize: { xs: "14px", sm: "16px" },
      lineHeight: { xs: 1.4, sm: 1.5 },
    },
  };

  if (!isAnswerChecked && ansText === selectedAnswer) {
    style = {
      ...style,
      backgroundColor: "#06B6D41A",
      border: "1px solid #06B6D4",
    };
  }

  if (isAnswerChecked) {
    if (ansPoints !== 0) {
      if (ansText === selectedAnswer) {
        style = {
          ...style,
          color: theme.palette.quizPopap.quizSelectorText,
          backgroundColor: "#66EF64B2",
          border: "1px solid #66EF64B2",
        };
      } else {
        style = {
          ...style,
          color: theme.palette.quizPopap.quizSelectorTrue.text,
          backgroundColor: "#66EF6433",
          border: `1px solid ${theme.palette.quizPopap.quizSelectorTrue.border}`,
        };
      }
    } else {
      if (ansText === selectedAnswer) {
        style = {
          ...style,
          backgroundColor: "#DD503E",
          color: "#FFFFFF",
        };
      }
    }
  }
  return style;
};
